var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Coleções e séries","titleIcon":"fas fa-layer-group"}},[_c('catalogo-crud',{attrs:{"tipo":"colecao","rotuloNovo":"NOVA COLEÇÃO","nomeSingular":"registro","placeholderBusca":"Pesquisar por descrição","campos":_vm.campos,"colunas":_vm.colunas,"filtroExtra":_vm.filtroExtra}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }